// src/sections/Guida.jsx — "Guida alla Piattaforma" placeholder (route /guida).
// Added per the Figma sidebar. No dedicated guide content yet — renders a
// coming-soon panel. Swap the body for real docs / an embedded guide later.
// SA in adminMode is bounced to /admin like the other member sections.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { BookMarked } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext.jsx';
import PageBand from '../components/ui/PageBand.jsx';
import { COLORS, FONT_SANS, RADII } from '../constants/theme.js';

const FONT = FONT_SANS;

export default function Guida() {
  const { isSuperadmin, adminMode } = useAuth();
  const { t: tShell } = useTranslation('shell');

  if (isSuperadmin && adminMode) return <Navigate to="/admin/users" replace />;

  return (
    <>
    {/* v193: the page header is the shared PageBand (portalled into the shell header's slot, on the
        avatar's row, like the Content Generator), titled with the sidebar's label. */}
    <PageBand title={tShell('nav.guide')} subtitle="Tutorial e risorse per usare al meglio la piattaforma" />
    <div style={{ padding: '32px 40px', fontFamily: FONT, color: COLORS.ink, maxWidth: '1100px' }}>

      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        gap: '14px', textAlign: 'center',
        padding: '56px 32px',
        border: `1px solid ${COLORS.border}`,
        borderRadius: RADII.control,
        background: '#FAFAFB',
      }}>
        <div style={{
          width: '56px', height: '56px', borderRadius: RADII.card,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#E7DEFF', color: COLORS.accent,
        }}>
          <BookMarked size={26} />
        </div>
        <div style={{ fontSize: '16px', fontWeight: 700 }}>Guida in arrivo</div>
        <div style={{ fontSize: '13px', color: COLORS.textSecondary, maxWidth: '420px', lineHeight: 1.5 }}>
          Stiamo preparando tutorial passo-passo e best practice per generare
          contenuti di qualità. Nel frattempo, esplora il Content Generator.
        </div>
      </div>
    </div>
    </>
  );
}
